import * as ms from 'milliseconds';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import SendCircleIcon from '@shared/assets/icons/v2/send-circle.svg';
import { MBAnimationBounceIn } from '@shared/components/animation';
import { MBTouchableIcon } from '@shared/components/touchable';
import { Colors } from '@shared/styles';

interface MBSendButtonProps {
  urgent: boolean;
  style?: StyleProp<ViewStyle>;
  onPress(): void;
  testID?: string;
}

export function MBSendButton({ urgent, style, onPress, testID }: MBSendButtonProps) {
  return (
    <MBAnimationBounceIn style={style} delay={ms.seconds(0.2)}>
      <MBTouchableIcon
        source={SendCircleIcon}
        color={urgent ? Colors.v2.red : Colors.v2.purple}
        noPadding
        onPress={onPress}
        testID={testID}
      />
    </MBAnimationBounceIn>
  );
}
